export  class ModeOfPaymentProperties {
  modeOfPaymentId: number = 0;
 
   name: string = "";


 status: boolean = false;

  creationUser: number = 0;
  //{ get; set; }
 modifyUser: number = 0;
    }
